import script from "./Entry.vue?vue&type=script&setup=true&lang=js"
export * from "./Entry.vue?vue&type=script&setup=true&lang=js"

import "./Entry.vue?vue&type=style&index=0&id=61ac120f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ac120f"]])

export default __exports__